// extracted by mini-css-extract-plugin
export default {"header":"Table_header__2hBwx","link":"Table_link__vj05s","active":"Table_active__hdt-i","inactive":"Table_inactive__Dwn1l"};